import React from "react";
import * as styles from "./List.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";

const List = ({
	header,
	items,
	noBackground = true,
	isIndexed = false,
	condensed = false,
	isSummary = false,
	className,
}) => {
	return (
		<>
			{header && <div className={styles.header}>{header}</div>}
			{items.map((item, index) => {
				const listClassName = classNames(
					{
						[styles["list"]]: true,
						[styles["has-index"]]: isIndexed,
						colored: index % 2 === 0 && !noBackground,
						[styles["with-divider"]]: noBackground,
						[styles["condensed"]]: condensed,
						[styles["summary"]]: isSummary,
					},
					className,
				);

				return (
					<div key={index} className={listClassName}>
						{/*<div className={styles["list-content"]}>*/}
						{isIndexed && <span className={styles["list-index"]}>{++index}</span>}
						{item}
						{/*</div>*/}
					</div>
				);
			})}
		</>
	);
};

List.propTypes = {
	header: PropTypes.node,
	items: PropTypes.array.isRequired,
	noBackground: PropTypes.bool,
	isIndexed: PropTypes.bool,
	isSummary: PropTypes.bool,
};

export default List;
